module.exports = __webpack_public_path__ + "static/media/grayscale.15ec0dfe.jpg";